import React from "react";

import { Link } from "../../utils/customLink";
import Image from "../../components/image";

import URLogo from "images/ur-logo-white.inline.svg";
import BWLogo from "images/bw-light-logo.inline.svg";


const VIHero = ({
  heroContent,
  heroTitle,
  containerClass,
  logoBoxDesc,
  logoBoxClass,
  contentClass,
  enquireLink,
  applyLink,
  heroLocalImg,
  mediaItemUrl,
  isBushwiseProgram
}) => {
  return (
    <>
      <section className={containerClass}>
        <Image
          imageAlt=""
          image={heroLocalImg}
          imageClass="!absolute z-0 object-cover w-full h-full top-0 left-0 bottom-0 right-0"
          sourceUrl={mediaItemUrl}
        />
        <div
          className={`relative flex justify-center ${contentClass} items-center w-full h-full z-10
    before:z-20 before:absolute before:md:hidden before:h-full before:w-full before:right-0 before:top-0 before:bg-gradient-to-b before:from-transparent before:to-[#040E16] before:planet:to-gray-darker `}
        >
          <div className="gvi-container flex flex-col justify-center items-center text-center md:text-left md:items-start z-30">
            {heroContent !== false && heroContent ? (
              heroContent
            ) : (
              <>
                <h1 className="font-body font-light text-white leading-[46px]">
                  Invest in your future
                </h1>
                <h1 className="text-[34px] md:text-[4rem] font-normal text-white leading-[2rem] md:leading-[73px] pb-9">
                  {heroTitle}
                </h1>
                <div className="flex flex-col md:flex-row gap-6 md:gap-3 w-full md:w-auto">
                  <Link
                    className="submit-button group flex justify-center items-center px-20 py-2"
                    to={applyLink}
                  >
                    <p className="pr-2 font-bold">Apply</p>
                  </Link>
                  <Link
                    className="callback-button group flex justify-center items-center px-20 py-2 bg-white hover:bg-black-lighter hover:text-white planet:bg-transparent planet:hover:bg-white planet:hover:text-gray-darker"
                    to={enquireLink}
                  >
                    <p className="pr-2">Enquire</p>
                  </Link>
                </div>
              </>
            )}
          </div>
          <div
            className={`card-shadow absolute flex flex-col text-center md:text-left items-center md:items-start bottom-0 md:bottom-auto md:right-0 md:top-1/2 md:translate-x-0 translate-y-1/2 md:-translate-y-1/2 w-11/12 md:w-auto px-6 py-5 md:p-10 gap-5 bg-black-lighter planet:bg-gray-darkest/50 md:planet:bg-gray-darkest/80 rounded-l-[5px] z-50 ${logoBoxClass}`}
          >
            <div className="md:pb-3 md:border-b border-white planet:border-[#3C3C3C]">
              <div
                className="md:pr-20 text-white text-mob md:text-base"
                dangerouslySetInnerHTML={{ __html: logoBoxDesc }}
              />
            </div>
            <div className="pt-5 md:pt-0 w-[60%] md:w-auto border-t md:border-0 border-white planet:border-[#3C3C3C]">
              {isBushwiseProgram ? (
                <BWLogo className="w-full md:w-auto h-14" />
              ) : (
                <URLogo className="w-full h-full" />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

VIHero.defaultProps = {
  containerClass:
    "flex flex-col items-center justify-center mx-auto hero-section relative z-20",
  logoBoxDesc: "",
  logoBoxClass: "",
  contentClass: "",
  enquireLink: "#",
  applyLink: "#"
};

export { VIHero };
